import React from "react";

import TablePaginator from "@app/analytics/components/TablePaginator";
import type { ReportListView } from "@app/analytics/types";
import type { Pagination } from "@app/common/hooks/usePagination";

import { Row } from "@rui/Stack";

import GroupReportsToggle from "./GroupReportsToggle";
import ReportViewSelector from "./ReportViewSelector";
import SourceFilterMenu from "./SourceFilterMenu";
import TagFilterMenu from "./TagFilterMenu";

interface ReportsMenuProps {
  isLoading: boolean;
  pagination: Pagination;
  view: ReportListView;
}

const ReportsMenu = ({ view, isLoading, pagination }: ReportsMenuProps) => {
  const onIncompleteReportsTab = view === "incomplete";

  return (
    <Row variant="apart" flexWrap="wrap" width="100%" marginY={2}>
      <Row variant="left" spacing={1}>
        {!onIncompleteReportsTab && (
          <>
            <ReportViewSelector />
            <GroupReportsToggle />
          </>
        )}
        <SourceFilterMenu />
        {!onIncompleteReportsTab && <TagFilterMenu />}
      </Row>
      <TablePaginator
        {...pagination}
        loading={isLoading}
        showPageSizeSelector
      />
    </Row>
  );
};

export default ReportsMenu;
